Ext.ns('mx.plugin');

/**
 * @constructor
 * @param (Object) config
 */
mx.plugin.GridFilter = function(config) {
    Ext.apply(this, config);
    this.addEvents('changestate', 'beforestoreload');
    mx.plugin.GridFilter.superclass.constructor.call(this);
}; // eo constructor

Ext.extend(mx.plugin.GridFilter, Ext.util.Observable, {
    putFill: true,
    labels: {
        buttonTextOff: 'Filter off',
        buttonTextOn: 'Filter on',
    },
    // {{{
    /**
     * private
     * @param {Ext.grid.GridPanel/Ext.grid.EditorGrid} grid reference to grid this plugin is used for
     */
    init: function(grid) {
        this.grid = grid;

        // setup toolbar container if id was given
        if ('string' === typeof this.toolbarContainer) {
            this.toolbarContainer = Ext.getCmp(this.toolbarContainer);
        }

        // do our processing after grid render and reconfigure
        grid.onRender = grid.onRender.createSequence(this.onRender, this);
        //		grid.reconfigure = grid.reconfigure.createSequence(this.reconfigure, this);
        this.state = this.defaultState || this.toggleFilter(true);
    }, // eo function init
    // }}}
    // {{{
    /**
     * private add plugin controls to <b>existing</b> toolbar and calls reconfigure
     */
    onRender: function() {
        var tb = this.grid.getTopToolbar();

        this.on(
            'changestate',
            function(/* boolean */ state) {
                this.button.setText(state ? this.labels.buttonTextOn : this.labels.buttonTextOff);
            },
            this
        );

        // add menu button
        tb.add({
            name: 'grid_filter_plugin_button',
            text: this.state ? this.labels.buttonTextOn : this.labels.buttonTextOff,
            iconCls: 'grid_filter_plugin_img',
            listeners: {
                click: {
                    fn: function(btn, e) {
                        function showFilter() {
                            this.button = btn;
                            var windowCfg = {
                                formClass: this.formClass,
                                autoHeight: true,
                                filter: this,
                                listeners: {
                                    show: function() {
                                        Ext.ux.event.Broadcast.fireEvent('netactivityfreeze', true, 'filtrable');
                                    },
                                    close: function() {
                                        Ext.ux.event.Broadcast.fireEvent('netactivityfreeze', false, 'filtrable');
                                    },
                                },
                            };
                            Ext.apply(windowCfg, this.windowCfg || {});
                            (this.window = new this.windowForm(windowCfg)).show();
                        }

                        if (this.grid.expander && this.grid.expander.grid) {
                            this.grid.collapseEditpanelByOutterAction(showFilter, this);
                        } else {
                            showFilter.call(this);
                        }
                    },
                    scope: this,
                },
            },
        });
        if (this.putFill) {
            tb.addFill();
        }
    }, // eo function onRender
    // }}}

    toFilterValue: function(/*object*/ oValue) {
        if (oValue instanceof Date) {
            return oValue.dateFormat(MXBT.getDateFormat('fulldatetime'));
        }
        if (oValue instanceof Array && oValue.length === 0) {
            return null;
        }
        return oValue.getRecordId ? oValue.getRecordId() : oValue;
    },

    checkFilter: function() {
        return this.filterConfig && this.filterConfig.store;
    },

    saveFilterForm: function(/*Ext.form.BasicForm*/ oForm) {
        if (this.checkFilter()) {
            if (!oForm && (this.window && this.window.form && this.window.form.getForm())) {
                oForm = this.window.form.getForm();
            }
            var fields = this.filterConfig.fields;
            var aDefaults = this.filterConfig.defaults || [];
            var store = this.filterConfig.store;
            var filter = {};
            if (fields && !this.filterConfig.useFormFieldsForFilter) {
                fields.forEach(function(item) {
                    var ctrl = oForm.findField(item);
                    var value = ctrl.isDirty() ? ctrl.getValue() : aDefaults[item];
                    filter[item] = {
                        filterValue: value ? this.toFilterValue(value) : null,
                        componentValue: value,
                    };
                }, this);
            } else {
                oForm.items.each(function(item) {
                    var value = item.getValue();
                    filter[item.name] = {
                        filterValue: value ? this.toFilterValue(value) : null,
                        componentValue: value,
                    };
                }, this);
            }
            store.setFilter(filter);
        }
    },

    loadFilterForm: function(/*Ext.form.BasicForm*/ oForm) {
        if (this.checkFilter()) {
            if (!oForm && (this.window && this.window.form && this.window.form.getForm())) {
                oForm = this.window.form.getForm();
            }
            var aFields = this.filterConfig.fields;
            var aDefaults = this.filterConfig.defaults || [];
            var filter = this.filterConfig.store.getFilter();
            if (filter || aDefaults) {
                if (aFields) {
                    aFields.forEach(function(sItem) {
                        var item = oForm.findField(sItem);
                        if (item) {
                            var itemValue = filter[sItem] ? filter[sItem]['componentValue'] : null;
                            item.setValue(itemValue ? itemValue : aDefaults[sItem]);
                        }
                    });
                } else {
                    oForm.items.each(function(item) {
                        var itemValue = filter[item.name] ? filter[item.name]['componentValue'] : null;
                        if (itemValue) {
                            item.setValue(itemValue);
                        }
                    });
                }
            }
        }
    },

    toggleFilter: function(/*boolean*/ bActive, /*boolean*/ bChangeState) {
        if (this.checkFilter()) {
            var aFields = this.filterConfig.fields;
            var oStore = this.filterConfig.store;
            var bHasAnyFilter = false;

            var filter = this.filterConfig.store.getFilter() || {};
            if (filter || this.filterConfig.defaults) {
                var newFilter = {};
                var aDefaults = this.filterConfig.defaults || [];
                if (aFields) {
                    aFields.forEach(function(sParam) {
                        var oValue = filter[sParam] ? filter[sParam]['componentValue'] : aDefaults[sParam];
                        if (oValue && bActive) {
                            bHasAnyFilter = true;
                            newFilter[sParam] = {
                                filterValue: this.toFilterValue(oValue),
                                componentValue: oValue,
                            };
                        } else {
                            newFilter[sParam] = null;
                        }
                    }, this);
                }
            }
            if (bChangeState) {
                this.fireEvent('changestate', bActive && bHasAnyFilter);
            }
            return bActive && bHasAnyFilter;
        }
    },

    getFilterValue: function(sName) {
        var aFilterValues = this.filterConfig.store.getFilter() || {};
        var aDefaults = this.filterConfig.defaults || [];
        if (aFilterValues || aDefaults) {
            return aDefaults[sName] ? aDefaults[sName] : aFilterValues[sName]['componentValue'];
        }
    },
}); // eo extend

// eof
